<template lang="pug">
    div.information
        div.iconWrapper
            v-icon(color="white") info

        div.infoText {{ text }}
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            text: VueTypes.string.def('')
        }
    };
</script>

<style lang="stylus" scoped>
    .information
        display: flex

    .iconWrapper
        margin-right: 10px
</style>
